import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../App/redux/store';
import { getAuthState } from '../features/auth/authSlice';
import routes from './routes';

const noSavedPath = new Set([
  '/premier-mot-de-passe',
  '/recuperation-mot-de-passe',
  '/',
]);

const publicPaths = routes.filter((f) => !f.isAuthRoute).map((m) => m.path);
function RedirectHandler() {
  const { isLogged, maintenancePageOnly } = useAppSelector(
    getAuthState,
    shallowEqual,
  );
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (maintenancePageOnly && location.pathname !== '/maintenance') {
      navigate('/maintenance', { replace: true });
    } else {
      const redirection = sessionStorage.getItem('prospec-redirection');

      if (!isLogged && !redirection && !noSavedPath.has(location.pathname)) {
        sessionStorage.setItem(
          'prospec-redirection',
          location.pathname + location.search,
        );
      }
      if (!isLogged && !publicPaths.includes(location.pathname)) {
        navigate('/connexion', { replace: true });
      }

      // if just logged
      if (
        isLogged &&
        (location.pathname === '/connexion' || location.pathname === '/')
      ) {
        // if memorized path is not /connexion or /, redirect to path, else go to dashboard
        const path =
          redirection && redirection !== '/' && redirection !== '/connexion'
            ? redirection
            : '/dashboard';

        navigate(path, { replace: true });

        sessionStorage.removeItem('prospec-redirection');
      }
    }
  }, [location.pathname, isLogged, navigate, maintenancePageOnly]);

  return null;
}

export default RedirectHandler;
